import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/noData_empty.svg'


const _hoisted_1 = { class: "h-screen" }
const _hoisted_2 = { class: "flex justify-between items-center px-4 py-4 border-b border-gray-200" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "text-xl font-semibold text-black-lp-300" }
const _hoisted_5 = { class: "text-sm text-black-lp-100 font-semibold" }
const _hoisted_6 = { class: "font-normal" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "x"
}, null, -1)
const _hoisted_8 = {
  class: "flex flex-col gap-y-4 overflow-y-auto",
  style: {"width":"578px","max-height":"514px"}
}
const _hoisted_9 = { class: "flex w-full" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2"
}
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "text-base font-semibold text-red-lp-100" }
const _hoisted_13 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-auto" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, " Total STT ", -1)
const _hoisted_15 = { class: "text-base font-semibold text-red-lp-100" }
const _hoisted_16 = { class: "font-normal" }
const _hoisted_17 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700" }
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-wrap gap-3"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700" }
const _hoisted_22 = { class: "font-medium" }
const _hoisted_23 = { class: "text-sm font-semibold text-black-lp-200 break-all" }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-y-2 py-8"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-40",
  alt: "no data"
}, null, -1)
const _hoisted_26 = { class: "text-center text-gray-lp-600 text-sm" }
const _hoisted_27 = {
  key: 1,
  class: "rounded-xl border border-gray-lp-1400 w-full"
}
const _hoisted_28 = { class: "bg-gray-lp-1000 rounded-xl w-full text-black-lp-300 text-sm" }
const _hoisted_29 = { class: "font-bold" }
const _hoisted_30 = /*#__PURE__*/_createVNode("th", { class: "p-4 text-left" }, "No.", -1)
const _hoisted_31 = { class: "p-4 text-left" }
const _hoisted_32 = { class: "p-4 text-left" }
const _hoisted_33 = { class: "p-4 text-left" }
const _hoisted_34 = { class: "p-4 text-left" }
const _hoisted_35 = { class: "bg-white" }
const _hoisted_36 = { class: "p-4" }
const _hoisted_37 = { class: "p-4" }
const _hoisted_38 = { class: "p-4" }
const _hoisted_39 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PreviewImagePod = _resolveComponent("PreviewImagePod")!
  const _component_PopupDepositDetail = _resolveComponent("PopupDepositDetail")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
      customBody: "p-4"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.depositIn")) + " " + _toDisplayString(_ctx.isSetorUang
                  ? _ctx.$t("codReconcile.dailyDeposit.tabMoney").toLowerCase()
                  : _ctx.$t("codReconcile.dailyDeposit.tabPackage").toLowerCase()), 1),
            _createVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.formattedDate) + " ", 1),
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.oleh")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.data.updatedByName), 1)
            ])
          ]),
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
          }, [
            _hoisted_7
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            (_ctx.isSetorUang)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("codReconcile.detail.nominalUang")), 1),
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.formatByCountry(_ctx.data.amount, { type: "money" })), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("span", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.data.stt.length) + " STT ", 1),
                _createVNode("span", _hoisted_16, " (" + _toDisplayString(_ctx.data.totalPiece) + " koli) ", 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.buktiFoto")), 1),
            (_ctx.data.photos?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.photos, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-1 rounded-lg bg-gray-lp-1000 flex items-center justify-center cursor-pointer",
                      style: {"height":"50px","width":"50px"}
                    }, [
                      _createVNode("img", {
                        src: item.url,
                        class: "w-full h-full object-cover rounded-lg",
                        alt: `Bukti foto perubahan berat koli ${index + 1}`,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)))
                      }, null, 8, ["src", "alt"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_20, "-"))
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.catatanLabel")), 1),
            _createVNode("span", _hoisted_23, _toDisplayString(_ctx.data.note || "-"), 1)
          ]),
          (!_ctx.data.stt.length)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.noData")), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_27, [
                _createVNode("table", _hoisted_28, [
                  _createVNode("thead", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("th", _hoisted_31, _toDisplayString(_ctx.isSetorUang ? _ctx.$t("codReconcile.dailyDeposit.noStt") : _ctx.$t("codReconcile.dailyDeposit.noSttShipment")), 1),
                    _createVNode("th", _hoisted_32, _toDisplayString(_ctx.isSetorUang ? _ctx.$t("codReconcile.dailyDeposit.layanan") : _ctx.$t("codReconcile.dailyDeposit.lastStatus")), 1),
                    _createVNode("th", _hoisted_33, _toDisplayString(_ctx.isSetorUang ? _ctx.$t("codReconcile.dailyDeposit.nominal") : _ctx.$t("codReconcile.dailyDeposit.koli")), 1),
                    _createVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.buktiSetor")), 1)
                  ]),
                  _createVNode("tbody", _hoisted_35, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.stt, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: index,
                        class: "border-t border-gray-lp-1400"
                      }, [
                        _createVNode("td", {
                          class: ["p-4", {
                    'rounded-bl-xl': index === _ctx.data.stt.length - 1
                  }]
                        }, _toDisplayString(index + 1), 3),
                        _createVNode("td", _hoisted_36, _toDisplayString(item.sttNo), 1),
                        _createVNode("td", _hoisted_37, _toDisplayString(_ctx.isSetorUang ? item.codType.replace("_", " ") : item.lastStatus), 1),
                        _createVNode("td", _hoisted_38, _toDisplayString(_ctx.isSetorUang ? _ctx.formatByCountry(item.amount, { type: "money", prefix: _ctx.prefixCurrency }) : item.totalPiece), 1),
                        _createVNode("td", {
                          class: ["p-4 text-right", {
                    'rounded-br-xl': index === _ctx.data.stt.length - 1
                  }]
                        }, [
                          _createVNode("div", _hoisted_39, [
                            _createVNode("button", {
                              class: "font-bold text-blue-lp-700 underline w-max",
                              onClick: () => _ctx.onOpenProof(item)
                            }, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.lihatBukti")), 9, ["onClick"])
                          ])
                        ], 2)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.isPreviewPhotos)
      ? (_openBlock(), _createBlock(_component_PreviewImagePod, {
          key: 0,
          data: _ctx.previewPhotos,
          onClose: _ctx.onClosePreview
        }, null, 8, ["data", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PopupDepositDetail, {
      modelValue: _ctx.isSeeProof,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSeeProof = $event)),
        _ctx.onCloseProof
      ],
      data: _ctx.selectedData,
      typeDeposit: _ctx.isSetorUang ? 'uang' : 'paket'
    }, null, 8, ["modelValue", "data", "onUpdate:modelValue", "typeDeposit"])
  ]))
}